export async function isValidAzureTenant(tenantId) {
    if (!tenantId || typeof tenantId !== 'string') {
        return false;
    }

    //  Basic GUID format validation
    const guidRegex =
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

    if (!guidRegex.test(tenantId)) {
        return false;
    }

    return true;
}
